export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    transactions() {
      return this.$store.state.userTransactions;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetTransactions');
  },
};
